<template>
<div>
  <v-card class="ma-3">
    <g-overlay :is-relay="isOverlay"/>
    <page-progress :is-loading="isLoading"/>
    <page-title icon="mdi-call-merge" title="Merged Invoices" :show-button="true" btn-link="/merged-invoice-list"/>
    <v-container class="pt-0" fluid>
      <v-row>
        <v-col cols="12" md="12" sm="12" xl="12" xs="12">
          <v-card>
            <v-data-table
                :headers="invoiceHeaders"
                :items="invoiceData"
                class="elevation-0 mt-0"
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-row>
                    <v-col cols="12" sm="8">
                      <g-p-search
                          :loading="isLoading"
                          class="mt-7"
                          @applySearch="handleSearch"
                      />
                    </v-col>
                  </v-row>
                </v-toolbar>
              </template>
              <template v-slot:no-data>
                Invoices is empty!
              </template>
              <template v-slot:item.liveLinks="{item}">
                <v-chip
                    class="ma-2"
                    color="green"
                    link
                    text-color="white"
                    @click.prevent.stop="liveLinkHandler(item)"
                >
                  View Live Link
                </v-chip>
              </template>
              <template v-slot:item.amount="{item}">
                {{ getAmountWithSymbol(item.amount) }}
              </template>
              <template v-slot:item.discount="{item}">
                {{ getAmountWithSymbol(item.discount) }}
              </template>
              <template v-slot:item.totalAmount="{item}">
                {{ getAmountWithSymbol(item.totalAmount) }}
              </template>
              <template v-slot:item.actions="{item}">
                <v-checkbox
                    color="primary"
                    v-model="item.isInCart"
                    :disabled="item.isInCart"
                    @click="addToCartHandler(item)"
                />
              </template>
            </v-data-table>
          </v-card>
        </v-col>
        <v-col cols="12" md="12" sm="12" xl="12" xs="12">
          <v-card>
            <v-data-table
                :headers="headers"
                :items="carts"
                hide-default-footer
                :disable-pagination="true"
            >
              <template v-slot:footer>
                <v-divider/>
                <v-toolbar flat>
                  <v-spacer/>
                  <confirm-button
                      :text="confirmBtnText"
                      :disabled="!carts.length"
                      @onButtonClick="onConfirmHandler"
                  />
                </v-toolbar>
              </template>
              <template v-slot:top>
                <v-toolbar dense flat>
                  Carts
                </v-toolbar>
              </template>
              <template v-slot:no-data>
                Cart is empty!
              </template>
              <template v-slot:body.append>
                <tr color="red">
                  <td colspan="5" style="text-align: right">
                    <h3>Sub Total</h3>
                  </td>
                  <td style="text-align: right"><h4>${{ subTotal }} USD</h4></td>
                  <td></td>
                </tr>
                <tr color="red">
                  <td colspan="5" style="text-align: right">
                    <h3>Discount</h3>
                  </td>
                  <td style="text-align: right"><h4>${{ discountTotal }} USD</h4></td>
                  <td></td>
                </tr>
                <tr color="red">
                  <td colspan="5" style="text-align: right">
                    <h3>Grand Total</h3>
                  </td>
                  <td style="text-align: right"><h4>${{ grandTotal }} USD</h4></td>
                  <td></td>
                </tr>
                <tr color="red" v-if="mergedInvoice.paymentMethod === 12 || mergedInvoice.paymentMethod === 13">
                  <td colspan="5" style="text-align: right">
                    <h3>Name</h3>
                  </td>
                  <td>
                    <v-text-field
                        v-model="mergedInvoice.name"
                        :rules="requiredFieldRule"
                        dense
                        label="Client Name"
                        placeholder="John Doe"
                        outlined
                        class="discount-field mt-2 mb-1"
                    />
                  </td>
                  <td></td>
                </tr>
                <tr color="red" v-if="mergedInvoice.paymentMethod === 12 || mergedInvoice.paymentMethod === 13">
                  <td colspan="5" style="text-align: right">
                    <h3>Phone</h3>
                  </td>
                  <td>
                    <v-text-field
                        type="text"
                        v-model="mergedInvoice.phone"
                        :rules="requiredFieldRule"
                        dense
                        placeholder="01711xxxxxx"
                        outlined
                        class="discount-field mt-2 mb-1"
                    />
                  </td>
                  <td></td>
                </tr>
                <tr color="red" v-if="mergedInvoice.paymentMethod === 12 || mergedInvoice.paymentMethod === 13">
                  <td colspan="5" style="text-align: right">
                    <h3>Address</h3>
                  </td>
                  <td>
                    <div class="content-edit-box">
                      <div
                          contenteditable="true"
                          class="contentEditTableBox"
                          ref="editTableBoxDetails"
                          v-html="ediTableContent"
                          @input="handleEditableInput($event)"
                      />
                    </div>
                    <span style="color: red;" v-if="!mergedInvoice.description">This field is required for BD payment</span>
                  </td>
                  <td></td>
                </tr>
                <tr color="red" v-else>
                  <td colspan="5" style="text-align: right">
                    <h3>Description</h3>
                  </td>
                  <td>
                    <div class="content-edit-box">
                      <div
                          contenteditable="true"
                          class="contentEditTableBox"
                          ref="editTableBoxDetails"
                          v-html="ediTableContent"
                          @input="handleEditableInput($event)"
                      />
                    </div>
                  </td>
                  <td></td>
                </tr>
                <tr color="red">
                  <td colspan="5" style="text-align: right">
                    <h3>Pay Method</h3>
                  </td>
                  <td style="text-align: right">
                    <v-select
                        v-model="mergedInvoice.paymentMethod"
                        :items="paymentMethods"
                        :rules="requiredFieldRule"
                        item-text="name"
                        item-value="id"
                        class="discount-field mt-2 mb-1"
                        dense
                        outlined
                    />
                  </td>
                  <td></td>
                </tr>

                <tr color="red">
                  <td colspan="5" style="text-align: right">
                    <h3>Is Send Mail?</h3>
                  </td>
                  <td>
                    <v-checkbox
                        v-model="mergedInvoice.isSendMail"
                    />
                  </td>
                  <td></td>
                </tr>
              </template>
              <template v-slot:item.liveLinks="{item}">
                <v-chip
                    class="ma-2"
                    color="green"
                    link
                    text-color="white"
                    @click.prevent.stop="liveLinkHandler(item)"
                >
                  View Live Link
                </v-chip>
              </template>
              <template v-slot:item.amount="{item}">
                ${{item.amount}}
              </template>
              <template v-slot:item.discount="{item}">
                ${{item.discount}}
              </template>
              <template v-slot:item.total="{item}">
                ${{item.total}}
              </template>
              <template v-slot:item.actions="{item}">
                <v-btn
                    color="error"
                    icon
                    @click="deleteHandler(item)"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
  <counter-link-popup
      :item="currentItem"
      :show="showLiveLink"
      @closePopupHandler="closePopupHandler"
  />
  <confirm-popup
      :show="showDeleteConfirm"
      confirm-event="onConfirmDelete"
      @closePopupHandler="showDeleteConfirm = false"
      @onConfirmDelete="deleteHandler(currentItem, true)"
  >
    <div>
      <span>Are you sure to delete this item?</span>
    </div>
  </confirm-popup>
  <confirm-popup
      :show="showConfirm"
      confirm-event="onConfirmOrder"
      @closePopupHandler="showConfirm = false"
      @onConfirmOrder="onConfirmHandler(true)"
  >
    <div>
        <span>Are you sure to confirm to submit merged invoices?
       </span>
    </div>
  </confirm-popup>
  <merged-invoice-mail-template :show="showMailTemplate" :item="responseData" @closeMailPopupHandler="closeLinkPopupHandler"/>
</div>
</template>

<script>
import GOverlay from "../components/GOverlay";
import PageProgress from "../components/PageProgress";
import PageTitle from "../components/PageTitle";
import GPAutoComplete from "../components/GPAutoComplete";
import AddButton from "../components/buttons/AddButton";
import Validation from "../components/mixins/Validation";
import CancelButton from "../components/buttons/CancelButton";
import ConfirmButton from "../components/buttons/ConfirmButton";
import ConfirmPopup from "../components/popups/ConfirmPopup";
import GPSearch from "@/components/GPSearch";
import CounterLinkPopup from "@/components/popups/CounterLinkPopup";
import {mapState} from "vuex";
import MergedInvoiceMailTemplate from "@/components/popups/MergedInvoiceMailTemplate";
export default {
  name: "MergedInvoice",
  components: {
    MergedInvoiceMailTemplate,
    CounterLinkPopup,
    GPSearch,
    ConfirmPopup,
    ConfirmButton,
    CancelButton,
    AddButton,
    GPAutoComplete,
    PageTitle,
    PageProgress,
    GOverlay
  },
  mixins: [Validation],
  data() {
    return {
      showMailTemplate: false,
      isOverlay: false,
      isLoading: false,
      showDeleteConfirm: false,
      showConfirm: false,
      formValid: true,
      showLiveLink: false,
      invoices: [],
      carts: [],
      currentSelection: '',
      ediTableContent: '',
      isSendMail: false,
      invoiceHeaders: [
        {
          text: 'Invoice No',
          value: 'invoiceNo'
        },
        {
          text: 'Email',
          value: 'email'
        },
        {
          text: 'Live Links',
          value: 'liveLinks'
        },
        {
          text: 'Amount',
          value: 'amount',
          align: 'right'
        },
        {
          text: 'Discount',
          value: 'discount',
          align: 'right'
        },
        {
          text: 'Total Amount',
          value: 'totalAmount',
          align: 'right'
        },
        {
          text: 'Actions', value: 'actions', sortable: false
        }
      ],
      invoiceData: [],
      headers: [
        {
          text: 'Invoice No.',
          value: 'invoiceNo'
        },
        {
          text: 'Email',
          value: 'email'
        },
        {
          text: 'Live Link',
          value: 'liveLinks'
        },
        {
          text: 'Amount',
          value: 'amount',
          align: 'right'
        },
        {
          text: 'Discount',
          value: 'discount',
          align: 'right'
        },
        {
          text: 'Total Amount',
          value: 'total',
          align: 'right'
        },
        {
          text: 'Actions', value: 'actions', align: 'right', sortable: false
        }
      ],
      currentItem: {},
      confirmBtnText: 'Confirm',
      mergedInvoice: {
        name: '',
        phone: '',
        email: '',
        description: '',
        paymentMethod: null,
        isSendMail: false
      },
      responseData: null
    }
  },
  mounted() {
    this.isOverlay = true;
    this.$store.dispatch('loadAllMethods', {status: true});
    if(!this.$route.params.id) {
      this.isOverlay = false;
      return;
    }

    this.confirmBtnText = 'Confirm Update';

    this.$store.dispatch("getByMergedInvoiceId", {id: this.$route.params.id})
        .then((response) => {
          let {id, name, phone, email, description, paymentMethod, merged_invoice_details} = response.data;
          this.ediTableContent = description;
          this.mergedInvoice = {id, name, email, phone, description, paymentMethod};
          merged_invoice_details.forEach((item) => {
            let {id, mergedId, invoiceId, invoice_details} = item;
            let {invoiceNo, email, amount, discount, totalAmount: total} = invoice_details;

            this.carts.push({id, mergedId, invoiceId, invoiceNo, email, amount, discount, total});
          })

          this.isOverlay = false;
        })
        .catch((errors)=> {
          this.setSnackBar({text: errors.message, type: 'error'});
          this.isOverlay = false;
        })

  },
  computed: {
    ...mapState({
      paymentMethods: function (state) {
        const methods = state.method.allPayMethods;
        const method = methods.find((data) => data.normalizedName === 'paddle');
        const  paymentMethod = this.mergedInvoice.paymentMethod;

        if(method) this.mergedInvoice.paymentMethod = paymentMethod ? paymentMethod : method.id;

        return methods;
      }
    }),
    subTotal() {
      return  Number.parseFloat(
          this.carts.reduce((prev, item) => {
            return Number.parseFloat(prev + Number.parseFloat(item.amount));
          }, 0)
      ).toFixed(2);
    },
    grandTotal() {
      return  Number.parseFloat(
          this.carts.reduce((prev, item) => {
            return Number.parseFloat(prev + Number.parseFloat(item.total));
          }, 0)
      ).toFixed(2);
    },
    discountTotal() {
      return  Number.parseFloat(
          this.carts.reduce((prev, item) => {
            return Number.parseFloat(prev + Number.parseFloat(item.discount));
          }, 0)
      ).toFixed(2);
    }
  },
  methods: {
    handleSearch(term) {
      if(term) {
        let _term = term.replace(/^\s+|\s+$/gm, '');

        this.$store.dispatch('invoiceSearch', {search: _term})
            .then((response) => {
              this.invoiceData = response.data.data.map((item) => {
                return {
                  ...item,
                  isInCart: false
                }
              });
             /* let order = this.carts.find((item) => item.invoiceNo === _term || item.email === _term);
              if(!order) {
                this.carts = [];
              }*/
              if(response.data.data.length === 0) {
                this.setSnackBar({text: "Unpaid invoice not found!", type: 'info'});
              }
            })
            .catch((errors) => {
              console.log(errors);
            })
      }
    },
    liveLinkHandler(item) {
      this.showLiveLink = true;
      this.currentItem = item;
    },
    getAmountWithSymbol(amount) {
      const _amount = Number.parseFloat(amount).toFixed(2);
      return `$${_amount}`;
    },
    addToCartHandler(item) {
      const {id, name, email, details, invoiceNo, amount, discount, totalAmount} = item;
      this.mergedInvoice.name = name;
      this.mergedInvoice.email = email;
      const index = this.carts.findIndex((data) => data.id === id);
      if(index > -1) return;

      let cart = {
        id,
        invoiceNo,
        email,
        invoiceId: id,
        details: details,
        amount: amount,
        discount: discount,
        total: totalAmount,
      };
      if (this.mergedInvoice.id) {
        cart.mergedId = this.mergedInvoice.id;
      }

      this.carts.push(cart);
    },
    deleteHandler(item, confirm = false) {

      if(!confirm) {
        this.showDeleteConfirm = true;
        this.currentItem = item;
        return;
      }

      const index = this.carts.findIndex((item) => item.id === this.currentItem.id);

      if (index > -1) {
        this.carts.splice(index, 1);
      }

      this.invoiceData = this.invoiceData.map((item, key) => {
        let isInCart = key === index ? false:  item.isInCart;

        return {
          ...item,
          isInCart
        }
      })

      this.showDeleteConfirm = false;
      this.currentItem = null;

    },
    onConfirmHandler(confirm = false) {
      let {name, phone, description, paymentMethod} = this.mergedInvoice;
      if(paymentMethod === 12 || paymentMethod === 13){
        if(!(name && phone && description)) {
          this.setSnackBar({text: 'For AamarPay or SSL Commerz payment name, phone and description field is required!', type: 'error'});
          return;
        }
      }
      if(!confirm) {
        this.showConfirm = true;
        return;
      }

      this.isOverlay = true;
      this.showConfirm = false;
      let _carts = [];

       this.carts.forEach((item) => {
         _carts.push({invoiceId: item.invoiceId});
       });

       let storeMethod = 'storeMergedInvoice';
       if(this.$route.params.id) storeMethod = 'updateMergedInvoice';

      this.$store.dispatch(storeMethod, {...this.mergedInvoice, totalAmount: this.grandTotal, carts: _carts})
          .then((response) => {
            this.responseData = response.data.invoice;
            this.showMailTemplate = true;
            this.isOverlay = false;
            if(this.$route.params.id) {
              this.setSnackBar({text: response.data.message, type: 'info'});
              this.$router.push({name: 'MergedInvoiceList', path: `/merged-invoice-list`});
            }
          })
          .catch((errors) => {
            this.isOverlay = false;
            this.setSnackBar({text: errors.response.data.message, type: 'error'});
          })

    },
    closePopupHandler() {
      this.showLiveLink = false;
      this.currentItem = null;
    },
    setSnackBar({text, type}) {
      this.$store.commit('SET_SNACKBAR', {text, type});
    },
    handleEditableInput (e) {
      this.mergedInvoice.description = e.target.innerHTML;
    },
    closeLinkPopupHandler() {
      this.showMailTemplate = false;
      this.carts = [];
      this.invoiceData = [];
      this.mergedInvoice = {
        name: '',
        email: '',
        description: '',
        paymentMethod: null,
        isSendMail: false
      }
    }
  }
}
</script>

<style scoped>

</style>